/**
 * useImpersonationTargets — admin-only list for the picker.
 *
 * Backed by GET /api/admin/users. `includeTest` mirrors the global
 * "Show test data" toggle.
 */

import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'
import type { ImpersonationTarget } from '../context/ImpersonationContext'

interface Args {
  includeTest: boolean
  roleFilter?: string
  enabled?: boolean
}

export function useImpersonationTargets({ includeTest, roleFilter, enabled = true }: Args) {
  return useQuery<ImpersonationTarget[]>({
    queryKey: ['admin', 'users', { includeTest, roleFilter }],
    queryFn: async () => {
      const params: Record<string, string> = {
        include_test: String(includeTest),
      }
      if (roleFilter) params.role = roleFilter
      const res = await api.get('/admin/users', { params })
      return res.data as ImpersonationTarget[]
    },
    enabled,
    staleTime: 30_000,
  })
}
